import React from "react";

import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";

class NewsList extends React.Component {
  componentDidMount() {
    this.props.updatePs();
  }

  render() {
    return (
      <List>
        {this.props.NewsDataObj.map((newsItem, index) => (
          <div key={index}>
            <ListItem>
              <ListItemText
                primary={
                  newsItem.title
                    ? newsItem.title.toString().replace("Fin24.com | ", "")
                    : ""
                }
                secondary={
                  newsItem.description
                    ? newsItem.description
                        .toString()
                        .replace("</strong>", "")
                        .replace("<strong>", "")
                    : ""
                }
              />
              <a href={newsItem.link ? newsItem.link : "#"} target="_blank">
                View
              </a>
            </ListItem>
            <Divider inset component="li" style={{ marginLeft: "0px" }} />
          </div>
        ))}
      </List>
    );
  }
}

export default NewsList;



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/NewsList.jsx